// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AttributeValueEdit_wrapper___glFI"};